import { asImageSrc } from "@prismicio/client"

import { useTranslation } from "@bounce/i18n"

import type { Interpolations } from "./useInterpolations"
import type { CityData } from "@/libs/bounce/cities"
import type { FormattedEvent } from "@/libs/prismic/event/types"
import { useEventUrl } from "@/libs/router"

export type UseSEOOptions = {
  city: Pick<CityData, "slug">
  event: FormattedEvent
  interpolations: Interpolations
}

export const useSEO = ({ event, city, interpolations }: UseSEOOptions) => {
  const [t] = useTranslation("marketing-ls-event")
  const { absolutePath } = useEventUrl({ event, city })

  const image = asImageSrc(event.image, { ar: "1.91:1", fit: "crop" })

  return {
    title: event.metaTitle ?? t("page.event.metaTitle", "{{EVENT_NAME}} | the ultimate guide | Bounce", interpolations),
    description:
      event.metaDescription ??
      t(
        "page.event.metaDescription",
        "Are you ready for {{EVENT_NAME}}? Find everything you need to know about how to get here, where to stay, and more. Store your stuff with Bounce bag storage and enjoy {{EVENT_NAME}} hands free.",
        interpolations,
      ),
    image,
    url: absolutePath,
  }
}
